<template>
    <Banner
        :show="banner.show"
        :type="banner.type"
        :message="banner.message"
        @close="closeBanner"
    >
        <component :is="banner.component">
            <slot />
        </component>
    </Banner>

    <Toast
        :show="toast.show"
        :type="toast.type"
        :message="toast.message"
        :duration="toast.duration"
        @close="closeToast"
    />

    <!-- 
        This part causes the component to get mounted. 
        The component gets mounted a second time in App.vue (<router-view/>). 
        This redundant mounting causes a noticeable flicker when loading a page.

        <component :is="layout">
            <slot />
        </component> 
    -->

        <AppLayoutDefault v-if="render && layout === 'Default'"><slot v-if="render"/></AppLayoutDefault>
        <AppLayoutAuth v-else-if="render && layout === 'Auth'"><slot /></AppLayoutAuth>
        <AppLayoutError v-else-if="render && layout === 'Error'"><slot /></AppLayoutError>
        <AppLayoutGuest v-else-if="render && layout === 'Guest'"><slot /></AppLayoutGuest>
        <AppLayoutSignup v-else-if="render && layout === 'Signup'"><slot/></AppLayoutSignup>

</template>

<script setup lang="ts">

import '@/assets/styles/style.scss'
import '@/assets/js/app.socialhp.js'

import { watch, provide, ref, onMounted, computed, nextTick, defineAsyncComponent, hydrateOnVisible } from 'vue'

const AppLayoutAuth = defineAsyncComponent({
  loader: () => import('./AppLayoutAuth.vue'),
  hydrate: hydrateOnVisible(),
})

const AppLayoutDefault = defineAsyncComponent({
  loader: () => import('./AppLayoutDefault.vue'),
  hydrate: hydrateOnVisible(),
})

const AppLayoutError = defineAsyncComponent({
  loader: () => import('./AppLayoutError.vue'),
  hydrate: hydrateOnVisible(),
})

const AppLayoutGuest = defineAsyncComponent({
  loader: () => import('./AppLayoutGuest.vue'),
  hydrate: hydrateOnVisible(),
})

const AppLayoutSignup = defineAsyncComponent({
  loader: () => import('./AppLayoutSignup.vue'),
  hydrate: hydrateOnVisible(),
})

import Banner from '../components/notif/Banner.vue'
import Toast from '../components/notif/Toast.vue'
import eventBus from '@/utils/eventBus'

import { useRoute } from 'vue-router'
import { useStore } from 'vuex'

const route = useRoute()
const store = useStore()

const render = ref(true)

const banner = ref({
    show: false,
    type: 'info',
    message: '',
    component: null,
})

const toast = ref({
    show: false,
    type: 'info',
    message: '',
    duration: 20000,
})

const showBanner = (type, message, component) => {
    banner.value.show = true
    banner.value.type = type
    banner.value.message = message
    banner.value.component = component
}

const showToast = (type, message, duration) => {
    toast.value.show = true
    toast.value.type = type
    toast.value.message = message
    toast.value.duration = duration
}

const closeBanner = () => {
    banner.value.show = false
}

const closeToast = () => {
    toast.value.show = false
}

const layout = computed(() => {
	return route.meta.layout
})

eventBus.on('layout.reload', async () => {
	render.value = false
	await nextTick()
	render.value = true
	console.log('rerendered')
})

onMounted(() => {
    document.getElementById('splash-container').style.display = 'none'
})

provide('showBanner', showBanner)
provide('showToast', showToast)

watch(
    () => store.state.appMessage.error.key,
    (current, previous) => {
        if (
            current &&
            current !== previous &&
            store.state.appMessage.error.message
        ) {
            showToast('failure', store.state.appMessage.error.message, 5000)
        }
    },
    { immediate: true },
)


</script>
